import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	@media ${Breakpoints.mobile} {
		padding: 0 var(--padding-2) var(--padding-5) var(--padding-2) !important;
	}
`;
